import type { PropsWithChildren } from 'react';

import ContestManageModals from './ContestManageModals';
import { ContestManageModalsContextProvider as BaseContestManageModalsContextProvider } from './ContestManageModalsContext';


function ContestManageModalsContextProvider({ children }: PropsWithChildren) {
  return (
    <BaseContestManageModalsContextProvider>
      {children}
      <ContestManageModals />
    </BaseContestManageModalsContextProvider>
  );
}


export default ContestManageModalsContextProvider;
